<template>
  <div class="main">
    <header class="centerH">
      <a @click="() => $router.push({ name: 'Center' })" class="btn-back">
        <img src="@/assets/img/i-left-grey.png" alt="" />
      </a>
      借阅规则
    </header>
    <div class="main ruleM">
      <div class="rules" v-html="ruleText"></div>
    </div>
    <loading :active.sync="isLoading" 
        color="#f4a84e"
        :is-full-page="fullPage"></loading>
  </div>
</template>
<script>
import { getRuleText } from "@/api/system_config";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components: {
            Loading
        },
  data() {
    return {
      ruleText: "",
      isLoading: false,
      fullPage: true,
      customerId:null
    };
  },
  methods: {
    handleRule() {
      this.isLoading = true
      this.customerId =  this.$route.query.customerId || this.$ls.get("CUSTOMER") 
      getRuleText(this.customerId)
        .then((res) => {
          this.isLoading = false
          this.ruleText = res.data.ruleText;
          // this.$message.success("加载成功");
        })
        .catch((error) => {
          this.isLoading = false
          // this.$message.error("加载失败");
        });
    },
  },
  mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
    this.handleRule();
  },
};
</script>
<style scoped>
@import "~@/assets/css/center.css";
</style>
